import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { AppsStorePage } from "@/components/collection-apps/apps-store-page";

// Configuración → Apps: tienda de apps de colecciones. `?tab=` elige la
// pestaña; `?app=` abre la ficha de esa app en el panel lateral.
export const Route = createFileRoute("/_authenticated/settings/_layout/apps/")({
  validateSearch: z.object({
    tab: z.enum(["store", "company", "installed"]).optional(),
    app: z.string().optional(),
  }),
  component: AppsSettingsPage,
});

function AppsSettingsPage() {
  const { tab, app } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <RouteGuardPermissions permissions={[{ module: "custom_fields", actions: ["read"] }]}>
      <AppsStorePage
        tab={tab ?? "store"}
        onTabChange={(next) => void navigate({ search: (s) => ({ ...s, tab: next === "store" ? undefined : next }), replace: true })}
        openApp={app ?? null}
        onOpenApp={(id) => void navigate({ search: (s) => ({ ...s, app: id ?? undefined }) })}
      />
    </RouteGuardPermissions>
  );
}
